import { Link } from 'react-router'

export function FinalCTA() {
	return (
		<section
			className="relative overflow-hidden text-white"
			style={{
				padding: '120px 0',
				background: 'var(--ink)',
			}}
		>
			<div
				className="pointer-events-none absolute left-1/2 -translate-x-1/2"
				style={{
					top: '-40%',
					width: 800,
					height: 600,
					background:
						'radial-gradient(ellipse at center, rgba(93,47,240,0.25) 0%, rgba(93,47,240,0) 60%)',
				}}
			/>

			<div className="relative mx-auto max-w-310 px-5 text-center md:px-10">
				<h2 className="mx-auto pb-6 max-w-200 text-white">
					Cessez de tout lire.
					<br />
					<span
						className="serif-italic"
						style={{ color: '#a89dff' }}
					>
						Commencez à voir clair.
					</span>
				</h2>
				<p
					className="mx-auto mb-10 max-w-125"
					style={{
						fontSize: 18,
						color: 'rgba(255,255,255,0.65)',
						lineHeight: 1.6,
					}}
				>
					Installation en 5 minutes. Résiliation à tout moment. Hébergé au
					Canada.
				</p>
				<div className="flex flex-wrap justify-center gap-3">
					<Link
						to="/signup"
						className="inline-flex items-center rounded-xl px-7 text-[15px] font-medium text-white transition-all hover:-translate-y-px"
						style={{
							height: 52,
							background: 'var(--brand)',
							boxShadow:
								'0 1px 0 rgba(255,255,255,0.15) inset, 0 8px 24px -8px var(--brand-glow)',
						}}
					>
						S'inscrire
					</Link>
					<Link
						to="/contact?topic=expert"
						className="inline-flex items-center rounded-xl px-6 text-[15px] font-medium text-white transition-colors"
						style={{
							height: 52,
							background: 'rgba(255,255,255,0.06)',
							border: '1px solid rgba(255,255,255,0.18)',
							backdropFilter: 'blur(12px)',
						}}
					>
						Parler à un expert
					</Link>
				</div>
			</div>
		</section>
	)
}
